import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { ButtonComponent, ContentDialogComponent, LinkComponent, SVG_ROOT } from '@pure/hive';

@Component({
    selector: 'copilot-onboarding-modal-inner',
    standalone: true,
    imports: [ContentDialogComponent, ButtonComponent, LinkComponent],
    templateUrl: './onboarding-modal.component.html',
    styleUrl: './onboarding-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OnboardingModalComponent {
    @Output() onboardingModalClose: EventEmitter<void> = new EventEmitter();
    @Output() onboardingModalAcked: EventEmitter<void> = new EventEmitter();

    @ViewChild('copilotOnboardingModalDialog')
    copilotOnboardingModalDialog!: ContentDialogComponent;

    protected backgroundImagePath: string;

    constructor(@Inject(SVG_ROOT) private readonly svgRoot: string) {
        // since it's not a hive svg we need to manually prepend the svg root
        this.backgroundImagePath = `${this.svgRoot}ai-onboarding-background.jpg`;
    }

    protected modalClose(): void {
        this.onboardingModalClose.emit();
    }

    protected modalAcked(): void {
        this.onboardingModalAcked.emit();
    }
}
